/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesViewType } from './WebApiModelsEnumerationTypesViewType';
import {
    WebApiModelsEnumerationTypesViewTypeFromJSON,
    WebApiModelsEnumerationTypesViewTypeFromJSONTyped,
    WebApiModelsEnumerationTypesViewTypeToJSON,
} from './WebApiModelsEnumerationTypesViewType';
import type { WebApiModelsViewColumn } from './WebApiModelsViewColumn';
import {
    WebApiModelsViewColumnFromJSON,
    WebApiModelsViewColumnFromJSONTyped,
    WebApiModelsViewColumnToJSON,
} from './WebApiModelsViewColumn';

/**
 * Represents a saved view configuration for displaying data
 * @export
 * @interface WebApiModelsView
 */
export interface WebApiModelsView {
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsView
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsView
     */
    companyId?: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesViewType}
     * @memberof WebApiModelsView
     */
    viewType?: WebApiModelsEnumerationTypesViewType;
    /**
     * 
     * @type {string}
     * @memberof WebApiModelsView
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsView
     */
    customListId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiModelsView
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WebApiModelsView
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsView
     */
    createdBy?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsView
     */
    updatedBy?: number | null;
    /**
     * 
     * @type {Array<WebApiModelsViewColumn>}
     * @memberof WebApiModelsView
     */
    viewColumns?: Array<WebApiModelsViewColumn> | null;
}

/**
 * Check if a given object implements the WebApiModelsView interface.
 */
export function instanceOfWebApiModelsView(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiModelsViewFromJSON(json: any): WebApiModelsView {
    return WebApiModelsViewFromJSONTyped(json, false);
}

export function WebApiModelsViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'viewType': !exists(json, 'viewType') ? undefined : WebApiModelsEnumerationTypesViewTypeFromJSON(json['viewType']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'customListId': !exists(json, 'customListId') ? undefined : json['customListId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (json['updatedAt'] === null ? null : new Date(json['updatedAt'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'viewColumns': !exists(json, 'viewColumns') ? undefined : (json['viewColumns'] === null ? null : (json['viewColumns'] as Array<any>).map(WebApiModelsViewColumnFromJSON)),
    };
}

export function WebApiModelsViewToJSON(value?: WebApiModelsView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'companyId': value.companyId,
        'viewType': WebApiModelsEnumerationTypesViewTypeToJSON(value.viewType),
        'name': value.name,
        'customListId': value.customListId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt === null ? null : value.updatedAt.toISOString()),
        'createdBy': value.createdBy,
        'updatedBy': value.updatedBy,
        'viewColumns': value.viewColumns === undefined ? undefined : (value.viewColumns === null ? null : (value.viewColumns as Array<any>).map(WebApiModelsViewColumnToJSON)),
    };
}

